module.exports = require('./lib/Observable.js').Observable;



//////////////////
// WEBPACK FOOTER
// ./node_modules/zen-observable/index.js
// module id = zSos
// module chunks = 0